import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getAddressproofs,
  addressproofListSuccessful,
  addressproofAddSuccessful,
  isModelVisible,
} from "./addressproofSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getAddressproof({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/addressproof/", params);
    yield put(addressproofListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddAddressproof({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/addressproof/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Addressproof Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getAddressproofs({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Addressproof. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(addressproofAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/addressproof/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Addressproof Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getAddressproofs({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Addressproof. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(addressproofAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteAddressproof({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(
      postDelete,
      "/masters/addressproof/" + countryID
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Addressproof has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getAddressproofs({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Addressproof has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetAddressproofs() {
  yield takeEvery("addressproof/getAddressproofs", getAddressproof);
}
export function* watchAddressproofAdd() {
  yield takeEvery("addressproof/addressproofAdd", AddAddressproof);
}

export function* watchAddressproofDelete() {
  yield takeEvery("addressproof/addressproofDelete", DeleteAddressproof);
}

function* AddressproofSaga() {
  yield all([
    fork(watchgetAddressproofs),
    fork(watchAddressproofAdd),
    fork(watchAddressproofDelete),
  ]);
}

export default AddressproofSaga;
